'use client'
import React from 'react'

export const CodeBlockIcon: React.FC = () => (
  <svg fill="none" height="12" viewBox="0 0 15 12" width="15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3738 8.62598L14.0404 5.95931L11.3738 3.29264M3.37376 3.29264L0.707092 5.95931L3.37376 8.62598M9.04043 0.625977L5.70709 11.2926"
      stroke="currentColor"
      strokeLinecap="square"
    />
  </svg>
)
